var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useGetModuleBuilderDropdownQuery, useLoadSystemConfigurationsQuery, useSaveStudioDropdownMutation, } from "@/store/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsV, faEdit, faTrash } from "@fortawesome/pro-solid-svg-icons";
import toast from "react-hot-toast";
import { LoaderImage } from "@/utils/loader";
import { useTranslation } from "react-i18next";
export default function DropdownEditor() {
    var _this = this;
    var _a, _b;
    var t = useTranslation(["common", "Administration", "ModuleBuilder"]).t;
    var _c = useParams(), dropdownName = _c.dropdownName, type = _c.type, packagesName = _c.packagesName, moduleName = _c.moduleName, menu = _c.menu, fieldName = _c.fieldName;
    var _d = useLoadSystemConfigurationsQuery(null), systemData = _d.data, error = _d.error;
    var navigate = useNavigate();
    var _e = useSaveStudioDropdownMutation(), saveStudioDropdownMutation = _e[0], _f = _e[1], saveData = _f.data, tokenAccessError = _f.error;
    var systemConfig = (systemData === null || systemData === void 0 ? void 0 : systemData.data) || {};
    var defaultLanguage = ((_a = systemConfig.languages) === null || _a === void 0 ? void 0 : _a.default) || "fr_FR" || "";
    var locales = Object.entries(((_b = systemConfig.languages) === null || _b === void 0 ? void 0 : _b.installed) || {}).map(function (l) { return ({ value: l[0], text: l[1] }); });
    var _g = useState([]), dropdown = _g[0], setDropdown = _g[1];
    var _h = useState(defaultLanguage), selectedLocale = _h[0], setSelectedLocale = _h[1];
    var _j = useState(false), loadingDropdown = _j[0], setLoadingDropdown = _j[1];
    var _k = useGetModuleBuilderDropdownQuery({
        dropdown: dropdownName || "",
        lang: selectedLocale,
    }), dropdown_response = _k.data, refetch = _k.refetch, isLoading = _k.isLoading, isFetching = _k.isFetching;
    var _l = useState(0), key = _l[0], setKey = _l[1]; // State to hold the key value
    useEffect(function () {
        loadDropdownData();
    }, [dropdownName, dropdown_response]);
    var loadDropdownData = function () { return __awaiter(_this, void 0, void 0, function () {
        var dropdownData, values;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, refetch()];
                case 1:
                    _b.sent();
                    setLoadingDropdown(true);
                    setDropdown([]);
                    try {
                        dropdownData = (_a = dropdown_response === null || dropdown_response === void 0 ? void 0 : dropdown_response.data) === null || _a === void 0 ? void 0 : _a.dropdown;
                        values = Object.entries(dropdownData).map(function (_a) {
                            var key = _a[0], value = _a[1];
                            return ({
                                key: key,
                                value: value,
                            });
                        });
                        setDropdown(values);
                    }
                    catch (error) {
                        //console.error(error);
                    }
                    finally {
                        setLoadingDropdown(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDragEnd = function (result) {
        if (!result.destination)
            return;
        var items = Array.from(dropdown);
        var reorderedItem = items.splice(result.source.index, 1)[0];
        items.splice(result.destination.index, 0, reorderedItem);
        setDropdown(items);
    };
    var _m = useState(false), isLoad = _m[0], setIsLoad = _m[1];
    var saveDropdown = function () { return __awaiter(_this, void 0, void 0, function () {
        var newLabels, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    newLabels = dropdown.map(function (item) { return [item.key, item.value]; });
                    setIsLoad(true);
                    return [4 /*yield*/, saveStudioDropdownMutation({
                            moduleName: dropdownName,
                            viewpackage: "studio",
                            body: {
                                dropdown_name: dropdownName,
                                dropdown_lang: selectedLocale,
                                list_value: newLabels,
                            },
                        }).unwrap()];
                case 1:
                    result = _a.sent();
                    setIsLoad(false);
                    refetch();
                    toast.success("Dropdown saved");
                    //  setKey((prev) => prev + 1);
                    if (fieldName) {
                        navigate("/modules/ModuleBuilder/".concat(type, "/packages/").concat(packagesName, "/").concat(moduleName, "/").concat(menu, "/").concat(fieldName));
                    }
                    else {
                        navigate("/modules/ModuleBuilder/".concat(type, "/lists"));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    setIsLoad(false);
                    toast.error("Dropdown not saved");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var cancelDropdown = function () {
        if (fieldName) {
            navigate(-1);
        }
        else {
            navigate("/modules/ModuleBuilder/dropdown/lists");
        }
        //navigate("/modules/ModuleBuilder/dropdown/lists");
    };
    var _o = useState(""), itemName = _o[0], setItemName = _o[1];
    var _p = useState(""), displayLabel = _p[0], setDisplayLabel = _p[1];
    var addDropdown = function () {
        // Prevent adding empty items
        if (!itemName.trim() || !displayLabel.trim()) {
            return;
        }
        // Add the new item to the dropdown list
        setDropdown(__spreadArray(__spreadArray([], dropdown, true), [{ key: itemName, value: displayLabel }], false));
        // Clear the input fields
        setItemName("");
        setDisplayLabel("");
    };
    var deleteDropdown = function (key) {
        setDropdown(dropdown.filter(function (item) { return item.key !== key; }));
    };
    var _q = useState(null), openInputIndex = _q[0], setOpenInputIndex = _q[1];
    var handleClickOutside = function (event) {
        if (openInputIndex !== null && !event.target.closest(".editable-input")) {
            setOpenInputIndex(null);
        }
    };
    useEffect(function () {
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openInputIndex]);
    var _r = useState(false), renderDroppable = _r[0], setRenderDroppable = _r[1];
    var renderDroppableAfterAnimationFrame = function () {
        if (!renderDroppable) {
            requestAnimationFrame(function () {
                setRenderDroppable(true);
            });
        }
    };
    return (_jsx("div", __assign({ className: "flex max-h-[50vh] overflow-y-auto max" }, { children: _jsx("div", __assign({ className: "flex-1" }, { children: _jsx("div", __assign({ className: "shadow rounded-md" }, { children: _jsxs("div", __assign({ className: "p-2" }, { children: [_jsxs("div", __assign({ className: "space-y-4" }, { children: [_jsxs("div", __assign({ className: "flex flex-row border-b-2 border-b-gray-200 py-2" }, { children: [_jsx("button", __assign({ className: "button primary", onClick: saveDropdown }, { children: t("app.LBL_SAVE_BUTTON_LABEL", { ns: "common" }) })), _jsx("button", __assign({ className: "bg-[rgb(var(--color-gray-400))] text-white button secondary", onClick: cancelDropdown }, { children: t("app.LBL_CANCEL_BUTTON_LABEL", { ns: "common" }) }))] })), _jsxs("div", __assign({ className: "flex items-center" }, { children: [_jsx("div", __assign({ className: " w-1/6" }, { children: _jsx("label", __assign({ className: "block  text-sm font-medium" }, { children: t("LBL_DROPDOWN_TITLE_NAME", { ns: "ModuleBuilder" }) })) })), _jsx("div", __assign({ className: "flex-1 text-md" }, { children: _jsxs("label", __assign({ className: "block font-medium " }, { children: [dropdownName, " ", loadingDropdown && "Loading..."] })) }))] })), _jsxs("div", __assign({ className: "flex items-center" }, { children: [_jsx("div", __assign({ className: "w-1/6" }, { children: _jsx("label", __assign({ className: "block text-sm  font-medium" }, { children: t("LBL_DROPDOWN_LANGUAGE", { ns: "ModuleBuilder" }) })) })), _jsx("div", __assign({ className: "flex-1 max-w-xs" }, { children: _jsx("div", __assign({ className: "relative" }, { children: _jsx("select", __assign({ value: selectedLocale, onChange: function (e) { return setSelectedLocale(e.target.value); }, className: "block border border-gray-300 rounded-sm py-1 px-2 text-sm focus:outline-none focus:ring focus:border-blue-300 mt-2", tabIndex: 1 }, { children: locales &&
                                                        locales.map(function (option, id) { return (_jsx("option", __assign({ value: option.value }, { children: option.text }), id)); }) })) })) }))] })), _jsxs("div", __assign({ className: "flex w-full " }, { children: [_jsx("div", __assign({ className: "w-1/6" }, { children: _jsx("label", __assign({ className: "block font-medium text-sm" }, { children: t("LBL_DROPDOWN_ITEMS", { ns: "ModuleBuilder" }) })) })), _jsxs("div", __assign({ className: "flex-1 text-sm mr-72 relative" }, { children: [_jsxs(DragDropContext, __assign({ onDragEnd: handleDragEnd }, { children: [renderDroppable && (_jsx(Droppable, __assign({ droppableId: "droppable" }, { children: function (provided) { return (_jsxs("div", __assign({}, provided.droppableProps, { ref: provided.innerRef, className: " p-0.5" }, { children: [dropdown.map(function (value, index) { return (_jsx(Draggable, __assign({ draggableId: "".concat(value.key), index: index }, { children: function (provided) { return (_jsx("div", __assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { className: "p-1.5 border border-gray-200 mb-1 " }, { children: _jsxs("div", __assign({ className: "flex items-center space-x-2" }, { children: [_jsx(FontAwesomeIcon, { icon: faArrowsV, className: "cursor-pointer", color: "var(--color-gray-600)" }), _jsx("div", __assign({ className: " font-medium text-[rgb(var(--color-gray-600))]" }, { children: value.key ? (value.key) : (_jsx("div", __assign({ style: { width: "45px" } }, { children: t("LBL_BLANK", {
                                                                                                ns: "ModuleBuilder",
                                                                                            }) }))) })), _jsx("span", __assign({ className: "px-0.5" }, { children: "/" })), openInputIndex === index ? (_jsx("div", __assign({ className: "w-full" }, { children: _jsx("input", { autoFocus: true, value: value.value, onChange: function (e) {
                                                                                                setDropdown(function (prev) {
                                                                                                    return prev.map(function (item, idx) {
                                                                                                        return idx === index
                                                                                                            ? __assign(__assign({}, item), { value: e.target.value }) : item;
                                                                                                    });
                                                                                                });
                                                                                            }, type: "text", className: "editable-input block w-1/2 border border-gray-300 rounded-sm px-2 text-sm  focus:outline-none focus:ring focus:border-blue-300" }) }))) : (_jsx("span", __assign({ className: "w-full" }, { children: value.value }))), _jsxs("div", __assign({ className: "flex  space-x-2" }, { children: [_jsx(FontAwesomeIcon, { icon: faEdit, onClick: function () {
                                                                                                    return setOpenInputIndex(index);
                                                                                                }, color: "var(--color-gray-600)", className: "cursor-pointer hover:text-blue-600" }), _jsx(FontAwesomeIcon, { icon: faTrash, onClick: function () {
                                                                                                    return deleteDropdown(value.key);
                                                                                                }, color: "var(--color-gray-600)", className: "cursor-pointer hover:text-blue-600" })] }))] })) }))); } }), value.key)); }), provided.placeholder] }))); } }))), renderDroppableAfterAnimationFrame()] })), (isLoading || isLoad || isFetching) && (_jsx(LoaderImage, {}))] }))] }))] })), _jsxs("div", __assign({ className: "grid grid-cols-2 mt-4 w-1/2 gap-20 " }, { children: [_jsxs("div", __assign({ className: "" }, { children: [_jsx("label", __assign({ className: "text-sm" }, { children: t("LBL_DROPDOWN_ITEM_NAME", { ns: "ModuleBuilder" }) })), _jsx("input", { type: "text", className: "block w-full bg-white border border-gray-300 rounded-sm py-1 px-2 text-sm focus:outline-none focus:ring focus:border-blue-300", value: itemName, onChange: function (e) { return setItemName(e.target.value); } })] })), _jsxs("div", { children: [_jsx("label", __assign({ className: "text-sm" }, { children: t("LBL_DROPDOWN_ITEM_LABEL", { ns: "ModuleBuilder" }) })), _jsx("input", { type: "text", className: "block w-full bg-white border border-gray-300 rounded-sm py-1 px-2 text-sm focus:outline-none focus:ring focus:border-blue-300", value: displayLabel, onChange: function (e) { return setDisplayLabel(e.target.value); } })] })] })), _jsx("div", __assign({ className: "my-2" }, { children: _jsx("button", __assign({ className: "button primary px-4 py-2 text-sm mr-2", onClick: addDropdown }, { children: t("app.LBL_ADD_BUTTON", { ns: "common" }) })) }))] })) })) })) }), "".concat(dropdownName).concat(key)));
}
